import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';

interface UserProfile {
  payment_status?: string;
}

export default function Verify() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  useEffect(() => {
    const handleVerification = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;

        if (session?.user) {
          const { data: profile } = await supabase
            .from('user_profiles')
            .select('payment_status')
            .eq('user_id', session.user.id)
            .single();

          if (profile?.payment_status === 'pending') {
            // If payment is pending, redirect to payment page
            navigate('/payment');
          } else {
            toast({
              title: "Email verified",
              description: "Your email has been verified. You can now access the platform.",
            });
            navigate('/');
          }
        }
      } catch (error: any) {
        toast({
          title: "Error",
          description: error.message,
          variant: "destructive",
        });
        navigate('/');
      }
    };

    handleVerification();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-2">Verifying your email...</h2>
        <p className="text-muted-foreground">Please wait while we verify your email address.</p>
      </div>
    </div>
  );
}